<template>
  <div
    ref="container"
    class="px-4 flex items-center justify-center leading-normal text-center overflow-hidden select-text"
    :style="{ fontSize: fontSize + 'px' }"
  >
    <span
      :id="isFontSizeStable ? 'exercises-content-text' : undefined"
      :key="isFontSizeStable"
      ref="text"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'HubExercisesContentText',

  props: {
    text: { type: String, required: true },
    minFontSize: { type: Number, default: 10 },
    maxFontSize: { type: Number, default: 20 }
  },

  data: () => ({
    fontSize: 20,
    isFontSizeStable: false
  }),

  watch: {
    text: 'resetAndResizeFont',
    isFontSizeStable() {
      console.log('isFontSizeStable', this.isFontSizeStable)
    }
  },

  created() {
    this.fontSize = this.maxFontSize
    this.debouncedSetStable = debounce(this.setFontSizeStable, 300)
  },

  mounted() {
    this.resizeFont()
    window.addEventListener('resize', this.resizeFont)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeFont)
    this.debouncedSetStable.cancel()
  },

  methods: {
    resetAndResizeFont() {
      this.isFontSizeStable = false
      this.fontSize = this.maxFontSize
      this.resizeFont()
    },

    setFontSizeStable() {
      this.isFontSizeStable = true
    },

    resizeFont() {
      this.$nextTick(() => {
        const container = this.$refs.container
        let fontSize = this.fontSize
        const containerWidth = container.offsetWidth
        const containerHeight = container.offsetHeight

        while (
          (container.scrollWidth > containerWidth ||
            container.scrollHeight > containerHeight) &&
          fontSize > this.minFontSize
        ) {
          fontSize--
          container.style.fontSize = `${fontSize}px`
        }

        this.fontSize = fontSize
        this.debouncedSetStable()
      })
    }
  }
}
</script>
